import octicons from '@primer/octicons';
import { useRoute, useRouter } from 'vue-router';
import { dialog } from '@/boot/dialog';
import { useQuasar } from 'quasar';
import notifications from '@/utils/app-notification';
import { useGeneralStore } from '@/store/generalStore';
import { useAuthStore } from '@/store/authStore';
import { useOrganizationStore } from '@/store/organizationStore';
import { useItemStore } from '@/store/itemStore';
import { useTimetrackingStore } from '@/store/timetrackingStore';
import { useUserStore } from '@/store/userStore';
import { useDataStore } from '@/store/dataStore';
import { useWorkflowStore } from '@/store/workflowStore';
import { useJobsStore } from '@/store/jobsStore';
import { useGanttStore } from '@/store/ganttStore';
import { useCadenceStore } from '@/store/cadenceStore';
import { useBoardStore } from '@/store/boardStore';
import { useStoredViewStore } from '@/store/storedViewStore';
import { useIntegrationsStore } from '@/store/integrationsStore';

octicons['file-directory'].heights['16'] =
  octicons['file-directory'].heights['24'];

export const useRoot = () => {
  return {
    $store: {
      general: useGeneralStore(),
      auth: useAuthStore(),
      organization: useOrganizationStore(),
      item: useItemStore(),
      data: useDataStore(),
      timetracking: useTimetrackingStore(),
      user: useUserStore(),
      workflow: useWorkflowStore(),
      jobs: useJobsStore(),
      gantt: useGanttStore(),
      cadence: useCadenceStore(),
      board: useBoardStore(),
      storedView: useStoredViewStore(),
      integrations: useIntegrationsStore(),
    },
    $router: useRouter(),
    $route: useRoute(),
    $notify: notifications,
    $dialog: dialog,
    $q: useQuasar(),
    $octicons: octicons,
    $qOcticons: (
      iconName: string,
      options: { size?: number; color?: string }
    ) => {
      if (!octicons[iconName]) {
        console.error(
          `The Octicon icon set does not have a "${iconName}" icon. Please use a valid icon.`
        );
        return;
      }
      const svg = octicons[iconName].toSVG({
        width: options?.size || 24,
        height: options?.size || 24,
        fill: options?.color || 'currentColor',
        xmlns: 'http://www.w3.org/2000/svg', // important - do not remove
      });
      const blob = new Blob([svg], { type: 'image/svg+xml' });
      return 'img:' + URL.createObjectURL(blob);
    },
  };
};
